// import ConnectedAppsTable from "components/settings/Integration/ConnectedApps";
import ConnectedAppsTable from "components/settings/Integration/ConnectedApps";
import NewConnectionApp from "components/settings/Integration/NewConnection";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getActiveConnectionAction } from "redux/action/activeConnectionsActions";
import { AppDispatch } from "redux/store";

export default function Integrations() {
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    // Fetch active connections when the component mounts
    dispatch(getActiveConnectionAction());
  }, []);

  const connectedAppsCount = useSelector(
    (state: any) => state?.ActiveServices?.data
  );

  return (
    <div>
      {connectedAppsCount?.length > 0 &&
      connectedAppsCount[0]?.isActiveConnection ? (
        // Render the list of connected apps if activeStatus is true
        <ConnectedAppsTable />
      ) : (
        <NewConnectionApp />
      )}
    </div>
  );
}
